/**
 * Allowed logging levels for the AgoraRTC.Logger module.
 */
export enum LogLevel {
  /** Outputs all logs. */
  Debug,
  /** Outputs logs of the INFO, WARNING and ERROR levels. */
  Info,
  /** Outputs logs of the WARNING and ERROR levels. */
  Warning,
  /** Outputs logs of the ERROR level. */
  Error,
  /** Outputs no logs. */
  None
}
